export const AXIOS_DISCONNECTED_FROM_SERVER = 'ECONNABORTED';

export const AXIOS_UNAUTHENTICATED_STATUS_CODE = 401;
export const AXIOS_UNAUTHORIZED_STATUS_CODE = 403;

export const AXIOS_AUTH_REFRESH_OPTIONS = {
  statusCodes: [AXIOS_UNAUTHENTICATED_STATUS_CODE],
  pauseInstanceWhileRefreshing: false,
};
